import { render, staticRenderFns } from "./SpacingSystem.vue?vue&type=template&id=54b44c8e&"
import script from "./SpacingSystem.vue?vue&type=script&lang=js&"
export * from "./SpacingSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports